import { useCallback, useMemo } from 'react'
import useUserStore from '@/user/userStore'
import { useUpdateName } from '@/user/userQueries'
import { NameFormValues } from './rules/nameSchema'

interface UseNameLogicResult {
    data: NameFormValues | undefined
    loading: boolean
    saving: boolean
    isSuccess: boolean
    onSubmit: (data: NameFormValues) => void
}

export function useNameLogic(): UseNameLogicResult {
    const { user, setUser } = useUserStore()
    const updateName = useUpdateName()

    const data = useMemo(() => {
        if (!user) return undefined

        return {
            salutation: user.salutation || '',
            firstName: user.firstName || '',
            middleName: user.middleName || '',
            lastName: user.lastName || '',
        }
    }, [user])

    const onSubmit = useCallback(
        (formData: NameFormValues) => {
            updateName.mutate(formData)
            if (user) {
                setUser({ ...user, ...formData })
            }
        },
        [updateName, user, setUser],
    )

    return {
        data,
        loading: false,
        saving: updateName.isPending,
        isSuccess: updateName.isSuccess,
        onSubmit,
    }
}
